import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Sentry removed - backend error tracking is sufficient for production monitoring
// Frontend errors are logged to console and can be monitored via browser DevTools
// If you need frontend error tracking, uncomment and configure Sentry below:
/*
import * as Sentry from '@sentry/react';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      if (event.request?.data) {
        const data = event.request.data as any;
        if (typeof data === 'object' && data !== null) {
          delete data.password;
          delete data.token;
          delete data.apiKey;
        }
      }
      return event;
    },
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'fb_xd_fragment',
      /Loading chunk [\d]+ failed/,
    ],
  });
}
*/

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 